import React from "react";
import "./About.css";
import heroImage from "../../images/hero-sobre-nos.jpg";
import firstImage from "../../images/AdvogadaSentadaComNote2.png";
import secondImage from "../../images/AdvogadaSentada2.png";

export default function About() {
  return (
    <div className="about-container">
      <section
        className="hero"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
      </section>
      <section className="info-section">
        <h1>Sobre Nós</h1>
        <div className="image-text-block">
          <img src={firstImage} alt="Bloco 1" className="first-image" />
          <p className="about-text">
            Sou advogada com atuação nas áreas de <span className="highlight">Direito Contratual, Família e Sucessões</span>, com foco em acolher e orientar as pessoas em momentos de transição, conflitos ou recomeços.
            Me formei em Direito em  pelo Centro Universitário de Belo Horizonte em Minas Gerais e concluí uma <span className="highlight">Pós-Graduação em Direito de Família e Sucessões pela Escola Brasileira de Direito (EBRADI)</span> em 2021. Desde então, venho me profissionalizando e aperfeiçoando meus atendimentos de forma empática, respeitando e individualizando a história de cada cliente.
          </p>
        </div>

        <div className="image-text-block reverse">
          <img src={secondImage} alt="Bloco 2" className="second-image" />
          <p className="about-text">
            Escolhi essa área porque acredito que o <span className="highlight">Direito deve ser uma ferramenta de amparo</span>, especialmente quando envolve vínculos familiares. Atuo em processos de <span className="highlight">guarda, divórcio, planejamento sucessório, inventário, testamentos, entre outros.</span> 
            Se você está em busca de um busca de um atendimento online, acessível, acolhedora e comprometida, será um prazer conversar com você.
          </p>
        </div>
      </section>
    </div>
  );
}
